// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 359) return "static/chunks/359-27057f2a4ea3597b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"b8a1a114392c6dc5","514":"46f16fdfe0e271af","695":"2732624547229cb7"}[chunkId] + ".js";
};